import { render, staticRenderFns } from "./customSettings.vue?vue&type=template&id=cad3a08e&scoped=true&"
import script from "./customSettings.vue?vue&type=script&lang=js&"
export * from "./customSettings.vue?vue&type=script&lang=js&"
import style0 from "./customSettings.vue?vue&type=style&index=0&id=cad3a08e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cad3a08e",
  null
  
)

export default component.exports